import React from 'react';

import MobileFlyoutMegaMenu from './MobileFlyoutMegaMenu/MobileFlyoutMegaMenu';
import MobileFlyoutDropdownMenu from './MobileFlyoutDropdownMenu/MobileFlyoutDropdownMenu';

import { MobileFlyoutProps } from './_props';

/**
 * MobileFlyout Component
 */

function MobileFlyout({ subMenuItem, mobileMenuActiveItem }: MobileFlyoutProps) {
  if (subMenuItem.id !== mobileMenuActiveItem) return null;

  if (subMenuItem.id === 'megamenTempID') {
    return <MobileFlyoutMegaMenu subMenuItem={subMenuItem} />;
  }

  return <MobileFlyoutDropdownMenu subMenuItem={subMenuItem} mobileMenuActiveItem={mobileMenuActiveItem} />;
}

/**
 * Exports
 */

export default MobileFlyout;
